import React from "react";
import classes from "./Header.module.css";
import mealsImage from '../../assets/meals2.jpg';
import HeaderCartButton from './HeaderCartButton';


const Header = (props) => {
    return (
        <React.Fragment>
            <header className={classes.header}>
                <h1>Krowarzywa</h1>
                <HeaderCartButton onClick={props.onShowCart} />
            
            </header>
            <div className={classes['main-image']}>
                <img src={mealsImage}  alt="a table full of delicious food"/>
            </div>
        </React.Fragment>
    );
};

export default Header;
